import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addSystemAction,
    updateSystemAction,
    deleteSystemAction
} from '../../../redux/actions/admin/adminAction';

export const TypesOfSystems = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'system': '' })
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'system': '' })
        setShow(false)
    };

    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateSystem(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addSystem(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteSystem(id)
    }

    const [typesSystemColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Types of System", field: 'system', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])

    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={props.system}
                defaultColDef={defaultColDef}
                columnDefs={typesSystemColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Types of System</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>

                    <Modal.Body>
                        <h3>Type of System</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="system"
                                name="system"
                                value={inputData.system}
                                onChange={handleChange}
                                placeholder="System"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const system = state.admin.system;
    return {
        system: system,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addSystem: (data) => dispatch(addSystemAction(data)),
        updateSystem: (id, data) => dispatch(updateSystemAction(id, data)),
        deleteSystem: (id) => dispatch(deleteSystemAction(id)),

    };
};



export default connect(mapStateToProps, mapDispatchToProps)(TypesOfSystems)


